import axios from '@/libs/api.request'

/**
 * 交付时间配置
 */
export const setDayCount = (data) => {
    return axios.request({
        url: '/api/admin/deliverydayconfig/save',
        data,
        method: 'post'
    })
}

/**
 * 导出交付记录
 */
export const exportDelivery = (city, car_type, banben, rn, s_date, e_date) => {
    let data ={
        city: city,
        car_type: car_type,
        banben: banben,
        rn: rn,
        s_date: s_date, 
        e_date: e_date,
    }
    return axios.request({
        url: '/api/admin/delivery/export',
        data,
        method: 'post'
    })
}